import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { Contract } from '../../model/contract';
import { ParkingContract } from '../../model/parking-contract';
import { ContractService } from '../../service/base/contract';
import { ApproveContractCommandHandler } from '../../service/command/approve-contact-command-handler.service';
import { ContractFormCommandHandlerResolver } from '../../service/command/contract-form-command-handler-resolver.service';
import { PrintContractCommandHandler } from '../../service/command/print-contract-command-handler.service';
import { PrintContractTerminationFormCommandHandler } from '../../service/command/print-contract-termination-form-command-handler';
import { PrintParkingContractFormCommandHandler } from '../../service/command/print-parkingcontract-command-handler';
import { ShowLeaseAgreementInvoicesCommandHandler } from '../../service/command/show-lease-agreement-invoices-command-handler';
import { TerminateContractCommandHandler } from '../../service/command/terminate-contract-command-handler.service';
import { WithdrawApprovalCommandHandler } from '../../service/command/withdraw-approval-command-handler.service';
import { WithdrawTerminationCommandHandler } from '../../service/command/withdraw-termination-command-handler.service';
import { ParkingContractService } from '../../service/data/parking-contract.service';
import { ContractFormComponentBase } from '../base/contract-form.base';
import { ActivatedRoute } from '@angular/router';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { standardCommand, Command } from '../../../core/model/command';
import { VoidContractCommandHandler } from '../../service/command/void-contract-command-handler.service';
import { ESignLeaseAgreementContractCommandHandler } from '../../service/command/esign-lease-agreement-document-command-handler.service';
import { UserAccountService } from '../../../common/service/user-account.service';
import { Features, ModuleNames } from '../../../common/model/account-definition';
import { ESignKeyRecieptCommandHandler } from '../../service/command/esign-key-reciept-document-command-handler.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { LeaseAgreementLogService } from '../../service/data/lease-agreement-log.service';
import { LeaseAgreementImdConsumptionService } from '../../service/data/lease-agreement-imd-consumption.service';
import { LanguageService } from '../../../core/service/language.service';

@Component({
    selector: 'app-parking-contract-form',
    templateUrl: './parking-contract-form.component.html',
    styleUrls: ['./parking-contract-form.component.scss'],
    providers: [
        ApproveContractCommandHandler,
        ContractFormCommandHandlerResolver,
        DeleteFormCommandHandler,
        PrintContractTerminationFormCommandHandler,
        PrintParkingContractFormCommandHandler,
        ShowLeaseAgreementInvoicesCommandHandler,
        TerminateContractCommandHandler,
        VoidContractCommandHandler,
        ESignLeaseAgreementContractCommandHandler,
        ESignKeyRecieptCommandHandler,
        WithdrawApprovalCommandHandler,
        WithdrawTerminationCommandHandler,
        PrintContractCommandHandler,
        { provide: ContractService, useExisting: ParkingContractService },
        { provide: DataService, useExisting: ParkingContractService },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ParkingContractFormComponent extends ContractFormComponentBase<Contract> {
  leaseAgreementDocumentCount = 0;
  constructor(
    activatedRoute: ActivatedRoute,
    dataService: ParkingContractService,
    dispatcher: CommandDispatcher,
    cdf: ColumnDefinitionFactory,
    cds: ColumnDefinitionService,
    fb: FormBuilder,
    fcf: FormControlExFactory,
    handlerResolver: ContractFormCommandHandlerResolver,
    messageService: MessageService,
    messageDispatcher: ComponentMessageDispatcher,
    navigation: NavigationService,
    userAccount: UserAccountService,
    logService: LeaseAgreementLogService,
    leaseAgreementImdConsumptionService: LeaseAgreementImdConsumptionService,
    languageService: LanguageService
  ) {
    super(
      messageDispatcher,
      cdf,
      fb,
      fcf,
      userAccount,
      cds,
      activatedRoute,
      dataService,
      messageService,
      navigation,
      dispatcher,
      handlerResolver,
      logService,
      leaseAgreementImdConsumptionService,
      languageService
    );

    this.AddSubscription(
      userAccount.current.subscribe({
        next: account => {
          if (account.hasAccess(ModuleNames.Messages, Features.ManageESignatures) && account.hasKeyReceiptWriteAccess()) {
            this.addMenuItemDefinition('COMMON.COMMAND.ESIGN_KEY_RECIEPT', leaseAgreementCommand.esignKeyReciept);
          }
          this.addMenuItemDefinition('LEASE_AGREEMENT.COMMAND.PRINT_PARKING_FORM', leaseAgreementCommand.printParkingForm);
          if (account.hasLeaseAgreementWriteAccess()) {
            this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
          }
          if (account.hasLeaseAgreementWriteAccess()) {
            this.addMenuItemDefinition('LEASE_AGREEMENT.COMMAND.VOID', leaseAgreementCommand.void);
          }
          if (account.hasLeaseAgreementWriteAccess()) {
            this.addMenuItemDefinition('DELETE_BTN', standardCommand.delete);
          }
        },
      })
    );
  }

  get parkingNumber(): string {
    const number = (this.dataContext.rentalObjectParkingNumber ?? '').trim();
    return number === '' ? 'COMMON.EMPTY' : number;
  }

  protected createModel(): Contract {
    let model = new ParkingContract();
    model.invoiceAddress.country = '';
    if (model.isNew && model.usage == null)
      model.usage = 'Bilplatsen uthyres i befintligt skick endast till uppställningsplats av personbil som används av hyresgäst(er).';
    return model;
  }

  linkDocument() {
    const cmd = new Command<Contract>(leaseAgreementCommand.linkDocument);
    cmd.context = this.dataContext;
    this.commandDispatcher.sendCommand(cmd);
  }
}
